import React from 'react'

import { Group, rem, Skeleton, Stack } from '@affstore-ds/uikit'

import { usePromoCardLoaderStyles } from './PromoCardLoader.styled'

export const PromoCardLoader = () => {
  const { classes } = usePromoCardLoaderStyles()

  return (
    <Stack w="100%" mih={rem(672)} className={classes.root}>
      {/* Image Section */}
      <Skeleton w="100%" height={262} mah={262} borderRadius={0} />

      {/* Card Content */}
      <Stack gap={16} p={16} pt={12} w="100%" flex={1}>
        {/* Badges Section */}
        <Group gap={8} wrap="wrap">
          <Skeleton w={200} height={24} borderRadius={8} />
        </Group>

        {/* Title */}
        <Skeleton w={180} height={24} borderRadius={8} />

        {/* Description */}
        <Stack gap={0}>
          <Skeleton w="100%" height={24} borderRadius={8} />
        </Stack>

        {/* Extra Content Area */}
        <Stack gap={16}>
          <Skeleton w="60%" height={40} borderRadius={8} />
        </Stack>

        {/* Generate Link Button */}
        <Skeleton w="100%" mt="auto" height={40} borderRadius={8} />
      </Stack>
    </Stack>
  )
}
